var SCM = SCM || {};

(function (ns, $) {

    function downloadCitations(e) {
        e.preventDefault();
        if (!SCM.CitationDownloadManager.getSelectedCitations().length) return;

        // Get the selected citation format (ris, enw, bibtex, etc.)
        var citationFormat = $(this).data('citation-format');

        // Set the download request URL to specify that citation format
        var $form = $('.js-download-citation');
        var action = $form.data('action-format') + citationFormat;
        $form.attr('action', action);

        // Add the citation IDs for download to the request
        var citations = SCM.CitationDownloadManager
            ? JSON.stringify(SCM.CitationDownloadManager.getSelectedCitationsData())
            : '';
        $('.js-download-citation-data').attr('value', citations);

        $form.submit();
    }
    
    ns.registerDownload = function () {
        $('.js-citation-format').on('click', downloadCitations);
    };

})(SCM.CitationDownloadSelector = SCM.CitationDownloadSelector || {}, jQuery);

(function ($, undefined) {
    $(SCM.CitationDownloadSelector.registerDownload());
})(jQuery);